/**
 * Um dependente do cidadão, espelho de `DependenteResponse` do back-end
 * (`api/sai/cartaservico/MeusDependentes`).
 *
 * Só o que a lista mostra. Nome social, nascimento, gênero, raça/cor, RG e CPF ficam gravados
 * e **não voltam**: não há tela que os exiba, e são dado pessoal de terceiros.
 */
export interface DependenteResponse {
  codDependenteDpd: number;
  desNomeDpd: string;
  desParentescoDpd: string;
}

/** O formulário do modal "Adicionar dependente". Tudo texto, como os campos entregam. */
export interface NovoDependente {
  nomeCompleto: string;
  nomeSocial: string;
  parentesco: string;
  /** `yyyy-MM-dd`, o valor do `<input type="date">`. */
  dataNascimento: string;
  genero: string;
  racaCor: string;
  rg: string;
  /** Com a máscara `000.000.000-00`; quem tira é `corpoDoDependente`. */
  cpf: string;
}

/**
 * Espelho de `Dependente.ParentescosValidos` do back-end, que recusa qualquer outro valor.
 * Mudar um lado exige mudar o outro.
 */
export const PARENTESCOS: readonly string[] = ['Filho(a)', 'Cônjuge', 'Pai/Mãe', 'Irmão/Irmã', 'Outro'];
